function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgMirLogo = function SvgMirLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 809 229"
    },
    viewBox: "0 0 809 229",
    height: "1em",
    width: "1em",
    y: "0px",
    x: "0px",
    id: "Layer_1"
  }, props), /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  }), /*#__PURE__*/React.createElement("style", {
    id: "style3",
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4DB45E;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n"), /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M218,0l0,0.1c-0.1,0-31.6-0.1-40,30c-7.7,27.6-29.4,103.8-30,105.9h-6c0,0-22.2-77.9-30-106   C103.6-0.1,72,0,72,0H0v229h72V93h3h3l42,136h50l42-135.9h6V229h72V0H218z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M481,0c0,0-21.1,1.9-31,24l-51,112h-6V0h-72v229l68,0v0c0,0,22.1-2,32-24l50-112h6v136h72V0H481z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M581,104v125h72v-73h78c34,0,62.8-21.7,73.5-52H581z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 47,
    x2: 809,
    y1: 47,
    x1: 570.9194,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop20",
    style: {
      stopColor: "#00B4E6"
    },
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop22",
    style: {
      stopColor: "#088CCB"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M731,0H570.9c8,43.6,40.7,78.6,83,90l0,0c9.6,2.6,19.7,4,30.1,4h123.4c1.1-5.2,1.6-10.5,1.6-16   C809,34.9,774.1,0,731,0z",
    className: "st1"
  })));
};
export default SvgMirLogo;